export const withPinnedIndex = (indexes: number[], pinnedIndex: number) => {
  if (pinnedIndex < 0 || indexes.includes(pinnedIndex)) return indexes

  return [...indexes, pinnedIndex].sort((a, b) => a - b)
}
